import React from "react";
import { Link } from "react-router-dom";
import logo_white from "assets/images/mainlogo_white.png";
import "./style.css";

const Footer = () => {
  return (
    <footer className="footer-modern">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8">

        {/* Top grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 pb-2">

          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img src={logo_white} alt="Vivcloud Technologies" className="h-9 w-auto" />
            </Link>
            <p className="footer-logo-tagline">
              Specialized IT services in AI, Java, React &amp; AWS — engineering
              solutions that modernize and scale your business.
            </p>
            <div className="flex gap-2 mt-5">
              <a
                href="https://www.facebook.com/profile.php?id=100085157191155"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-btn"
                aria-label="Facebook"
              >
                <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a>
              <a
                href="https://twitter.com/VIVCLOUDTECH"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-btn"
                aria-label="Twitter"
              >
                <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/vivcloud-technologies-pvt-ltd"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-btn"
                aria-label="LinkedIn"
              >
                <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Company */}
          <div>
            <p className="footer-col-title">Company</p>
            <div className="flex flex-col gap-2">
              <Link to="/about">About Us</Link>
              <Link to="/services">Services</Link>
              <Link to="/careers">Careers</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>

          {/* Services */}
          <div>
            <p className="footer-col-title">Services</p>
            <div className="flex flex-col gap-2">
              <Link to="/services">AI &amp; Machine Learning</Link>
              <Link to="/services">Java &amp; Spring Boot</Link>
              <Link to="/services">React Development</Link>
              <Link to="/services">AWS Cloud</Link>
              <Link to="/services">Full-Stack Development</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="footer-col-title">Get In Touch</p>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-2">
                <svg className="mt-0.5 flex-shrink-0 opacity-50" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
                <a href="mailto:vivcloudtech@gmail.com" rel="noopener noreferrer">
                  vivcloudtech@gmail.com
                </a>
              </div>
              <div className="flex items-start gap-2">
                <svg className="mt-0.5 flex-shrink-0 opacity-50" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
                <a href="tel:+918604042743">+91 86040 42743</a>
              </div>
              <div className="flex items-start gap-2">
                <svg className="mt-0.5 flex-shrink-0 opacity-50" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                </svg>
                <span className="text-sm" style={{ color: "#b0bec5" }}>
                  D-53, Ground Floor, Vibhuti Khand,<br />Gomti Nagar, Lucknow, India
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <hr className="footer-divider" />
        <div className="footer-bottom flex flex-col sm:flex-row items-center justify-between gap-2">
          <span>
            &copy; {new Date().getFullYear()} Vivcloud Technologies Private Limited. All rights reserved.
          </span>
          <div className="flex gap-4">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-use">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
